export const COOKIE_CONSENT_MAX_HEIGHT = 215;
